import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDetailsContext } from '../germplasm-details.context';
import { GermplasmProgenitorsDetails } from '../../shared/germplasm/model/germplasm.model';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { GermplasmDetailsUrlService } from '../../shared/germplasm/service/germplasm-details.url.service';
import { Router } from '@angular/router';
import { GermplasmProgenitorsContext } from '../../entities/germplasm/progenitors/germplasm-progenitors.context';
import { EDIT_GERMPLASM_PERMISSION, GERMPLASM_AUDIT_PERMISSION, VIEW_NAMES_PERMISSION } from '../../shared/auth/permissions';
import { BreedingMethodTypeEnum } from '../../shared/breeding-method/model/breeding-method-type.model';
import { PedigreeTreeComponent } from './pedigree-tree.component';
import { Principal } from '../../shared';
import { MAX_NAME_DISPLAY_SIZE } from '../../app.constants';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-pedigree-pane',
    templateUrl: './pedigree-pane.component.html'
})
export class PedigreePaneComponent implements OnInit, OnDestroy {

    GERMPLASM_AUDIT_PERMISSION = GERMPLASM_AUDIT_PERMISSION;
    MODIFY_PEDIGREE_PERMISSIONS = [...EDIT_GERMPLASM_PERMISSION, 'MODIFY_PEDIGREE'];
    PEDIGREE_ACTIONS_PERMISSIONS = [...this.MODIFY_PEDIGREE_PERMISSIONS, ...GERMPLASM_AUDIT_PERMISSION];

    @ViewChild(PedigreeTreeComponent, { static: true }) pedigreeTreeComponent: PedigreeTreeComponent;
    subscriptionsManager: SubscriptionsManager = new SubscriptionsManager();
    germplasmProgenitorsDetails: GermplasmProgenitorsDetails;
    isIframeLoaded: boolean;

    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;

    constructor(public languageservice: JhiLanguageService,
                public translateService: TranslateService,
                private eventManager: JhiEventManager,
                public germplasmDetailsContext: GermplasmDetailsContext,
                private germplasmService: GermplasmService,
                public germplasmDetailsUrlService: GermplasmDetailsUrlService,
                private router: Router,
                private germplasmProgenitorsContext: GermplasmProgenitorsContext,
                private principal: Principal) {
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.registerGermplasmNameChanged();
        this.loadProgenitorDetails();
    }

    registerGermplasmNameChanged() {
        this.subscriptionsManager.add = this.eventManager.subscribe('progenitorsChanged', (event) => {
            this.loadProgenitorDetails();
            this.pedigreeTreeComponent.loadTree();
            this.germplasmDetailsContext.notifyGermplasmDetailChanges();
        });
    }

    loadProgenitorDetails() {
        this.germplasmService.getGermplasmProgenitorsDetails(this.germplasmDetailsContext.gid).toPromise().then((value) => {
            this.germplasmProgenitorsDetails = value;
        });
    }

    editPedigree(progenitorsDetails: GermplasmProgenitorsDetails): void {
        this.germplasmProgenitorsContext.germplasmProgenitorsDetails = progenitorsDetails;
        this.router.navigate(['/', {
            outlets: {
                popup: null
            }
        }], { skipLocationChange: true, queryParamsHandling: 'merge' }).then(() => {
            this.router.navigate(['/', {
                outlets: {
                    popup: 'germplasm-progenitors-dialog/' + this.germplasmDetailsContext.gid
                }
            }], {
                queryParamsHandling: 'merge',
                skipLocationChange: true
            });
        });
    }

    isGenerative(): boolean {
        return this.germplasmProgenitorsDetails && this.germplasmProgenitorsDetails.breedingMethodType === BreedingMethodTypeEnum.GENERATIVE;
    }

    showGenerativeProgenitorColumn(): boolean {
        return this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION) && this.isGenerative();
    }

    showDerivativeProgenitorColumn(): boolean {
        return this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION) && !this.isGenerative();
    }
    openProgenitorsAuditChanges(): void {

        this.router.navigate(['/', {
            outlets: {
                popup: null
            }
        }], { skipLocationChange: true, queryParamsHandling: 'merge' }).then(() => {
            this.router.navigate(['/', { outlets: { popup: `germplasm/${this.germplasmDetailsContext.gid}/progenitors/audit-dialog` }, }], {
                queryParamsHandling: 'merge'
            });
        });
    }

}
